import { render } from "./signOut.vue?vue&type=template&id=2071e38a"
import script from "./signOut.vue?vue&type=script&lang=js"
export * from "./signOut.vue?vue&type=script&lang=js"

import "./signOut.vue?vue&type=style&index=0&id=2071e38a&lang=css"

import exportComponent from "C:\\Users\\Yuting_Shiu\\Desktop\\mes-chunyu-modify\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__